import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/videoData';

export default function CategoryCards() {
  const navigate = useNavigate();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            内容分类
          </h2>
          <p className="text-sm text-foreground-600">海量资源，总有你想看的</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={`/category/${cat.slug}`}
              onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); }}
              className="group flex flex-col items-center gap-3 p-5 bg-background-100 hover:bg-background-200 rounded-lg cursor-pointer transition-all duration-200"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`} style={{ color: 'oklch(var(--primary-500))' }}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}